export const config = {
    apiKey: "AIzaSyDTep9dMNqAOIssbslzMmdqTBW4dCTTk2o",
    authDomain: "whisky-tasting-invitation.firebaseapp.com",
    databaseURL: "https://whisky-tasting-invitation-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "whisky-tasting-invitation",
    storageBucket: "whisky-tasting-invitation.appspot.com",
    messagingSenderId: "668616437301",
    appId: "1:668616437301:web:e129a629e8dd1ae6bfcb7c"
};